import store from '../../index'
import * as usuario from '@/api/usuario'
import { convertSelect } from '../../../service/collection'

const state = {
  list: [],
  listTodos: [],
  listaSelect: [],
  filtros: {page: 1},
  countPage: 0,
  modalAdd: false,
  modalEdit: false,
  modalConfDelUnidade: false,
  modalConfDesativa: false,
  maximoAtualUsuariosUnidade: {
    maximoUsuarios: 0,
    numeroUsuariosAtual: 0,
    permiteMaisUsuarios: true
  }
}

const mutations = {
  SETUSUARIOS (state, payload) {
    let data = []
    payload.list.forEach(e => {
      e.processando = e.processando ? e.processando : false
      data.push(e)
    })
    state.list = data
  },
  SETUSUARIOSTODOS (state, payload) {
    state.listTodos = payload
  },
  SETUSUARIOSSELECT (state, payload) {
    state.listaSelect = convertSelect(payload.instancia)
  },
  HIDDEMODAL (state) {
    state.modalAdd = false
    state.modalEdit = false
    state.modalConfDelUnidade = false
  },
  MODALADD (state) {
    state.modalAdd = !state.modalAdd
  },
  MODALEDIT (state) {
    state.modalEdit = !state.modalEdit
  },
  MODALCONFDELUNIDADE (state) {
    state.modalConfDelUnidade = !state.modalConfDelUnidade
  },
  MODALCONFDESATIVAUSUARIO (state) {
    state.modalConfDesativa = !state.modalConfDesativa
  },
  SETPAGE (state, payload) {
    state.filtros.page = payload
  },
  SETPAGINATE (state, payload) {
    if (payload === 1) state.countPage = 0
    else state.countPage = payload
  },
  SETFILTROS (state, payload) {
    if (payload) {
      state.filtros = payload
    }
  },
  SETUSUARIOSPORUNIDADE (state, payload) {
    if (payload) {
      state.maximoAtualUsuariosUnidade = payload.instancia
    }
  },
  SETPROCESSANDO (state, payload) {
    state.list[payload].processando = true
  }
}

const actions = {
  hiddeModal: function ({ commit }) {
    commit('HIDDEMODAL')
  },
  modalAdd: function ({ commit }) {
    commit('MODALADD')
  },
  modalEdit: function ({ commit }) {
    commit('MODALEDIT')
  },
  modalConfDelUsuario: function ({ commit }) {
    commit('MODALCONFDELUNIDADE')
  },
  modalConfDesativaUsuario: function ({ commit }) {
    commit('MODALCONFDESATIVAUSUARIO')
  },
  async get ({ commit }, payload) {
    let data = await usuario.get(payload)
    return data
  },
  async getSemLoad ({ commit }, payload) {
    let retorno = await usuario.getSemLoad(payload)
    return retorno.instancia
  },
  async getUsuarios ({ commit }, payload) {
    commit('SETFILTROS', payload)
    let envelope = await usuario.getUsuarios(payload)
    let data = envelope.instancia
    commit('SETUSUARIOS', data)
    commit('SETPAGINATE', data.pages)
  },
  async getUsuariosTodos ({commit}, payload) {
    commit('SETFILTROS', payload)
    let envelope = await usuario.getUsuariosTodos(payload)
    let data = envelope.instancia
    commit('SETUSUARIOSTODOS', data)
  },
  async getUsuariosFiltro ({ commit, dispatch }) {
    let envelope = await usuario.getUsuarios(state.filtros)
    let data = envelope.instancia
    if (state.filtros.page > data.pages) dispatch('setPage', data.pages)
    else {
      commit('SETUSUARIOS', data)
      commit('SETPAGINATE', data.pages)
    }
  },
  async getUsuariosSelect ({ commit }, payload) {
    let data = await usuario.usuariosSelect(payload)
    commit('SETUSUARIOSSELECT', data)
  },
  async add ({ commit }, payload) {
    payload.unidade.id = payload.unidade.value
    payload.grupo.id = payload.grupo.value
    return usuario.add(payload)
  },
  async addFila ({ commit }, payload) {
    payload.unidade.id = payload.unidade.value
    payload.grupo.id = payload.grupo.value
    return usuario.addFila(payload)
  },
  async edit ({ commit }, payload) {
    if (payload.unidade) {
      payload.unidade.id = payload.unidade.value
    }
    if (payload.grupo) {
      payload.grupo.id = payload.grupo.value
    }
    let retorno = await usuario.edit(payload)
    return retorno.instancia
  },
  async editFila ({ commit }, payload) {
    if (payload.unidade) {
      payload.unidade.id = payload.unidade.value
    }
    if (payload.grupo) {
      payload.grupo.id = payload.grupo.value
    }
    let retorno = await usuario.editFila(payload)
    return retorno.instancia
  },
  async editPerfil ({ commit }, payload) {
    return usuario.editPerfil(payload)
  },
  async status ({ commit }, payload) {
    return usuario.editStatus(payload)
  },
  async statusFila ({ commit }, payload) {
    return usuario.editStatusFila(payload)
  },
  async delUsuario ({ commit }, payload) {
    try {
      let retorno = await usuario.delUsuario(payload)
      return retorno
    } catch (e) {
      return e
    }
  },
  async delUsuarioFila ({ commit }, payload) {
    try {
      let retorno = await usuario.delUsuarioFila(payload)
      return retorno
    } catch (e) {
      return e
    }
  },
  async desativaUsuario ({ commit }, payload) {
    try {
      let retorno = await usuario.editStatus(payload)
      return retorno
    } catch (e) {
      return e
    }
  },
  async desativaUsuarioFila ({ commit }, payload) {
    try {
      let retorno = await usuario.editStatusFila(payload)
      return retorno
    } catch (e) {
      return e
    }
  },
  async trocaSenha ({commit}, payload) {
    let retorno = await usuario.trocaSenha(payload)
    if (payload.senha_comissao) store.dispatch('auth/corrigeAuthSenhaComissionamento')
    store.dispatch('auth/refresh')
    return retorno
  },
  setPage (context, payload) {
    context.commit('SETPAGE', payload)
    context.dispatch('getUsuarios', state.filtros)
  },
  async trocaUnidadeFoco (context, payload) {
    return usuario.trocaFoco({ id: payload })
  },
  async enviaAcesso (context, payload) {
    return usuario.enviaAcesso(payload)
  },
  async getNumeroMaximoUsuarios ({ commit }, context, payload) {
    let data = await usuario.numeroMaximoUsuariosPorUnidade()
    commit('SETUSUARIOSPORUNIDADE', data)
  },
  fakeProcessando ({ state, commit }, payload) {
    const usuarioIndex = state.list.findIndex(u => u.id === payload)
    commit('SETPROCESSANDO', usuarioIndex)
  },
  async validaNovoUsuario ({ commit }, payload) {
    let envelope = await usuario.validaNovoUsuario(payload)
    let data = envelope.instancia
    return data
  },
  async recuperaSenhaComissao ({ state }, payload) {
    try {
      return usuario.recuperaSenhaComissao(payload)
    } catch (e) {
      return e
    }
  },
  async alteraPromotora ({ state }, payload) {
    await usuario.alteraPromotora(payload)
    store.dispatch('auth/alteraPromotora', payload)
  }
}

export default { namespaced: true, state, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/gerenciador/usuario.js